import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import CategoryButtons from './CategoryButtons';
import { apiGet } from '../services/api';

function SearchSection() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function getFirstData() {
      try {
        const res = await apiGet('/api/v1/categories');
        if (!res.ok) throw new Error('categories');
        const data = await res.json();
        setCategories(Array.isArray(data.data) ? data.data : []);
      } catch {
        setCategories([]);
      }
    }

    getFirstData();
  }, []);
  return (
    <section className="container-fluid bg-home2">
      <div className="container">
        <Row>
          <Col className="col-xs-8">
            <h6 className="sub-title">Discover premium remote jobs, effortlessly</h6>
            <h1 className="fw-semibold mb-3" style={{ fontSize: '2.8rem', lineHeight: '1.2' }}>
              Find Your Perfect Remote Job
              <br />
              <span style={{ color: '#0078C3' }}>Work From Anywhere</span>
            </h1>
            <p className="lead text-muted mb-0">Real salaries. Real responses. Handpicked remote jobs from companies that respect your time.</p>

            {/*This is search section*/}

            <div className="height justify-content-center align-items-center">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="search">
                  <i className="fa fa-search"></i>
                  <input type="text" className="form-control" placeholder="Search for Remote Jobs"/>
                  <button className="btn btn-info">Search Jobs</button>
                </div>
              </div>
            </div>
            <div>
            </div>
            <CategoryButtons categories={categories} />
          </Col>
          <Col className="col-xs-4 align-content-center">
            <img src="/process-02.png" alt="Search for remote jobs" align="right"/>
          </Col>
        </Row>
        <Row>

        </Row>
      </div>
    </section>
  )
}

export default SearchSection